import { Interp } from '../../lib/render.jsx';

export default function Celebrate({ v }) {
  if (!v.showCelebrate) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "98", "padding": "20px" }}>
        <div className="gp-venster" style={{ "width": "min(400px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "alignItems": "center", "gap": "16px", "boxSizing": "border-box", "animation": "gpPartyPop .42s cubic-bezier(.22,1.4,.4,1) both" }}>
          <div style={{ "fontSize": "44px", "lineHeight": "1", "animation": "gpPartyBob 1.6s ease-in-out infinite" }}>
            🎺
          </div>
          <div style={{ "display": "flex", "flexDirection": "column", "alignItems": "center", "gap": "6px", "textAlign": "center" }}>
            <div style={{ "fontSize": "24px", "fontWeight": "700", "lineHeight": "1.2" }}>
              <Interp v={v.celebrateLine} />
            </div>
            <div style={{ "fontSize": "15px", "fontWeight": "600", "color": "var(--tekst-2)", "overflowWrap": "anywhere" }}>
              “
              <Interp v={v.celebrateTitle} />
              ”
            </div>
          </div>
          <div style={{ "width": "100%", "height": "26px", "border": "3px solid var(--ink)", "borderRadius": "999px", "background": "var(--lila)", "boxShadow": "3px 3px 0 var(--ink)", "overflow": "hidden", "boxSizing": "border-box" }}>
            {' '}
            <div style={{ "height": "100%", "borderRadius": "999px", "background": "repeating-linear-gradient(115deg,var(--roze) 0 14px,var(--roze) 14px 28px)", "animation": "gpFill .9s cubic-bezier(.35,.85,.3,1) both" }} />
            {' '}
          </div>
          {v.celebrateBusy ? (<>
            <div style={{ "fontSize": "13px", "fontWeight": "700", "color": "var(--tekst-3)" }}>
              Even ophangen…
            </div>
          </>) : null}
          {v.celebrateReady ? (<>
            <button onClick={v.celebrateGo} className="gp-btn pink" style={{ "width": "100%", "justifyContent": "center", "fontSize": "19px", "fontWeight": "600", "padding": "15px", "borderRadius": "16px" }}>
              Ga naar de paal!
            </button>
          </>) : null}
        </div>
      </div>
      {' '}
    </>
  );
}
